export  const  defaultTexts={
    title:'Smartlife.am',
    description:"Smartlife.am",
}
